export default ({ id, event, isUsed, user, checkedInAt, ...rest }) => ({
  id,
  event,
  isUsed,
  user,
  checkedInAt
});



// WEBPACK FOOTER //
// ./src/models/PassModel.js